import React, { memo, ReactNode, useMemo } from 'react'

import styled from '@emotion/styled'

import { Text, TextButton, textWrap } from '@surglogs-app/ui'
import { WrapInToolTip } from '@surglogs-app/ui.tooltip'

const StyledButton = styled(TextButton)`
  ${textWrap};
`

const buildSignature = (signature: any) => {
  if (signature?.userName || signature?.user_name) {
    return (
      <StyledButton>{signature?.userName || signature?.user_name}</StyledButton>
    )
  }

  return null
}

type Place = 'top' | 'right' | 'bottom' | 'left'

interface SignatureToolTipBoxProps {
  children?: ReactNode
  src?: string
  width?: number
  height?: number
  place?: Place
  signature?: any
  fallback?: string
}

export const SignatureToolTipBox = memo(
  ({
    children,
    src,
    width = 200,
    height = 100,
    place = 'left',
    signature,
    fallback,
  }: SignatureToolTipBoxProps) => {
    const noSignatureText = typeof fallback === 'undefined' ? 'N/A' : fallback
    const imageSrc = src || signature?.url
    const tooltipText = useMemo(
      () => <img {...{ src: imageSrc, width, height, alt: 'signature' }} />,
      [height, imageSrc, width],
    )

    return (
      <WrapInToolTip
        {...{
          place,
          hidden: !imageSrc,
          tooltipText,
        }}>
        <Text>{children || buildSignature(signature) || noSignatureText}</Text>
      </WrapInToolTip>
    )
  },
)
